import { ClickAwayListener, createStyles, makeStyles, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useDocumentData, useLocalization, useViewerState } from "../../hooks/index.js";
const useStyles = makeStyles(() => {
  return createStyles({
    typography: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      margin: '0 2.5em'
    },
    nameWrapper: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    textField: {
      flexShrink: 0
    },
    notFocusedText: {
      flexShrink: 0
    }
  });
});
/**
 * Document widget component for paging
 */
export const DocumentTitlePager = props => {
  const classes = useStyles(props);
  const {
    documentData
  } = useDocumentData();
  const viewerState = useViewerState();
  const localization = useLocalization();
  const [isFocused, setIsFocused] = useState(false);
  const [currentValue, setCurrentValue] = useState(viewerState.activePage);
  const gotoPage = page => {
    let pageInt = typeof page === 'string' ? parseInt(page, 10) : page;
    if (!isNaN(pageInt)) {
      pageInt = Math.max(pageInt, 1);
      pageInt = Math.min(pageInt, documentData.pageCount);
      viewerState.pageToGo.setValue({
        page: pageInt
      });
    }
  };
  return /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: () => setIsFocused(false)
  }, /*#__PURE__*/React.createElement(Typography, {
    onClick: () => setIsFocused(true),
    variant: "h6",
    color: "inherit",
    title: documentData.documentName,
    className: classes.typography
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.nameWrapper
  }, documentData.documentName, "\xA0"), isFocused ? /*#__PURE__*/React.createElement("form", {
    onSubmit: ev => {
      gotoPage(currentValue);
      ev.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    className: classes.textField,
    title: localization.gotoPage,
    onChange: ev => setCurrentValue(ev.currentTarget.value),
    onBlur: () => gotoPage(currentValue),
    defaultValue: viewerState.activePage,
    type: "number",
    required: true,
    InputLabelProps: {
      shrink: true
    },
    inputProps: {
      min: 1,
      max: documentData.pageCount,
      style: {
        textAlign: 'center'
      }
    },
    margin: "dense"
  })) : /*#__PURE__*/React.createElement("div", {
    className: classes.notFocusedText
  }, viewerState.activePage, " / ", documentData.pageCount)));
};
//# sourceMappingURL=document-title-pager.js.map